export default __webpack_public_path__ + "media/vendor/paper-dashboard-2-pro-html-v2.0.1/assets/img/flags/FI-21153a526ed9c8b50b9b7346329f9e7e.png";